<template>
  <div>
    <div @click="onLoad">
      <qrcode-vue id="qrcodeBox" :size="qrcodeVue.size" :value="'h5v_' + form.mainid" :logo="qrcodeVue.logo"
        :bgColor="qrcodeVue.bgColor" :fgColor="qrcodeVue.fgColor"></qrcode-vue>
    </div>
    <div style="position: absolute;left:-999999px;width: 100%;">
      <div id="capture" class="qr-image-warp">
        <div class="logo">Henkel</div>
        <div class="content">
          <div class="title">
            <span>
              <svg t="1659756139056" class="icon" viewBox="0 0 1158 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="1759" width="70" height="70">
                <path
                  d="M975.162386 219.279719H821.786947a43.825404 43.825404 0 0 1-43.816421-43.825403v-53.463579c0-66.443228 54.065404-120.508632 120.508632-120.508632 66.452211 0 120.508632 54.065404 120.508631 120.508632v53.463579a43.825404 43.825404 0 0 1-43.825403 43.816421zM975.162386 1022.517895H821.786947a43.825404 43.825404 0 0 1-43.816421-43.816421V707.853474a43.825404 43.825404 0 0 1 43.825404-43.825404h153.366456a43.825404 43.825404 0 0 1 43.825403 43.825404v270.848a43.816421 43.816421 0 0 1-43.825403 43.816421z"
                  fill="#D55400" p-id="1760"></path>
                <path
                  d="M332.449684 219.279719H179.074246a43.825404 43.825404 0 0 1-43.816421-43.825403v-53.463579c0-66.443228 54.056421-120.508632 120.508631-120.508632 66.443228 0 120.508632 54.065404 120.508632 120.508632v53.463579a43.825404 43.825404 0 0 1-43.825404 43.816421zM332.449684 1022.517895H179.074246a43.825404 43.825404 0 0 1-43.816421-43.816421V707.853474a43.825404 43.825404 0 0 1 43.816421-43.825404h153.375438a43.825404 43.825404 0 0 1 43.825404 43.825404v270.848a43.816421 43.816421 0 0 1-43.825404 43.816421z"
                  fill="#E87E04" p-id="1761"></path>
                <path
                  d="M1049.752702 751.669895H104.492912C48.119018 751.669895 2.245614 705.805474 2.245614 649.431579V233.876211c0-56.373895 45.864421-102.247298 102.247298-102.247299h945.25979c56.373895 0 102.247298 45.873404 102.247298 102.256281v415.537403c0 56.382877-45.873404 102.247298-102.247298 102.247299z"
                  fill="#F2C500" p-id="1762"></path>
                <path
                  d="M1049.752702 131.628912H577.122807v620.040983h472.620912c56.382877 0 102.256281-45.864421 102.256281-102.247299V233.876211c0-56.373895-45.873404-102.247298-102.247298-102.247299z"
                  fill="#F59D00" p-id="1763"></path>
                <path
                  d="M263.931509 490.945123c-4.57207 13.329965-34.941754 12.332912-37.762246 0l-9.62021-43.861334-9.629193 43.861334c-2.856421 12.503579-33.630316 13.150316-37.753264 0l-36.82807-112.900491c-3.817544-11.407719 24.333474-19.851228 27.576141-8.515369l28.133052 94.953544 14.623439-62.562807c2.236632-10.087298 25.519158-10.078316 27.755789 0l14.623439 62.562807 28.133053-94.944561c3.233684-11.317895 31.348772-2.946246 27.57614 8.506386l-36.82807 112.909473zM355.372912 420.612491h27.764772c11.416702 0 11.767018 22.213614 0 22.213614h-27.755789v31.465544h49.601123c11.443649 0 11.802947 25.168842 0 25.168842H339.087719c-6.296702 0-12.593404-2.964211-12.593403-8.883649V373.050386c0-5.928421 6.287719-8.892632 12.593403-8.892632h65.886316c11.802947 0 11.434667 25.177825 0 25.177825h-49.610105v31.276912zM453.658947 499.460491c-6.287719 0-12.584421-2.964211-12.584421-8.883649V372.861754c0-6.10807 7.221895-8.695018 14.434807-8.695017 7.221895 0 14.434807 2.586947 14.434807 8.695017v101.420913h42.199579c11.102316 0 11.102316 25.177825 0 25.177824h-58.475789zM588.970667 389.335579c-10.554386 0-16.662456 5.928421-16.662456 18.50386v49.053193c0 12.584421 6.10807 18.50386 16.842105 18.503859 14.803088 0 15.737263-11.281965 16.294175-18.503859 0.54793-6.844632 6.844632-8.695018 14.246176-8.695018 9.997474 0 14.623439 2.586947 14.623438 13.698246 0 48.900491-90.875509 57.254175-90.875509-5.003228v-49.044211c0-62.39214 90.875509-53.122246 90.875509-6.853614 0 11.111298-4.625965 13.698246-14.434807 13.698246-7.778807 0-14.066526-2.039018-14.434807-8.695018-0.197614-4.814596-0.745544-16.662456-16.473824-16.662456zM662.276491 456.892632v-49.044211c0-31.833825 19.797333-43.690667 45.343439-43.690667 25.537123 0 45.53207 11.856842 45.53207 43.690667v49.044211c0 31.833825-19.994947 43.681684-45.53207 43.681684-25.546105 0-45.352421-11.84786-45.352421-43.681684z m61.98793-49.044211c0-12.773053-6.287719-18.512842-16.653474-18.512842-10.365754 0-16.473825 5.739789-16.473824 18.50386v49.053193c0 12.773053 6.10807 18.50386 16.473824 18.503859s16.662456-5.730807 16.662457-18.503859v-49.044211zM851.617684 451.530105c-4.13193 6.997333-14.803088 7.455439-18.683509 0l-17.587649-32.211087v71.257824c0 11.856842-28.878596 11.856842-28.878596 0V378.610526c0-10.545404 7.221895-14.434807 14.443789-14.434807 10.356772 0 14.803088 1.113825 22.384281 14.434807l19.069754 33.324913 19.060772-33.324913c7.590175-13.320982 12.036491-14.434807 22.393263-14.434807 7.401544 0 14.434807 3.889404 14.434807 14.434807v111.975299c0 11.856842-28.869614 11.856842-28.869614 0v-69.407439l-17.767298 30.360702zM961.931228 420.612491h27.764772c11.416702 0 11.767018 22.213614 0 22.213614h-27.755789v31.465544h49.601122c11.443649 0 11.802947 25.168842 0 25.168842h-65.886315c-6.287719 0-12.593404-2.964211-12.593404-8.883649V373.050386c0-5.928421 6.287719-8.892632 12.593404-8.892632h65.886315c11.802947 0 11.434667 25.177825 0 25.177825h-49.601122v31.276912z"
                  fill="#808285" p-id="1764"></path>
                <path
                  d="M619.690667 448.197614c-7.392561 0-13.707228 1.841404-14.264141 8.712982-0.54793 7.212912-1.455158 18.485895-16.267228 18.485895-5.12 0-9.18007-1.347368-12.036491-4.140912v28.770807c25.878456 5.317614 57.200281-9.404632 57.200281-38.121544 0-11.111298-4.64393-13.707228-14.641404-13.707228z m-42.576842-83.438035v28.654035c2.811509-2.739649 6.817684-4.087018 11.838877-4.087018 15.746246 0 16.303158 11.865825 16.473824 16.653474 0.386246 6.664982 6.664982 8.712982 14.434807 8.712983 9.817825 0 14.461754-2.604912 14.461755-13.707228 0-27.17193-31.348772-41.570807-57.200281-36.226246zM662.276491 456.892632v-49.044211c0-31.833825 19.797333-43.690667 45.343439-43.690667 25.537123 0 45.53207 11.856842 45.53207 43.690667v49.044211c0 31.833825-19.994947 43.681684-45.53207 43.681684-25.546105 0-45.352421-11.84786-45.352421-43.681684z m61.98793-49.044211c0-12.773053-6.287719-18.512842-16.653474-18.512842-10.365754 0-16.473825 5.739789-16.473824 18.50386v49.053193c0 12.773053 6.10807 18.50386 16.473824 18.503859s16.662456-5.730807 16.662457-18.503859v-49.044211zM851.617684 451.530105c-4.13193 6.997333-14.803088 7.455439-18.683509 0l-17.587649-32.211087v71.257824c0 11.856842-28.878596 11.856842-28.878596 0V378.610526c0-10.545404 7.221895-14.434807 14.443789-14.434807 10.356772 0 14.803088 1.113825 22.384281 14.434807l19.069754 33.324913 19.060772-33.324913c7.590175-13.320982 12.036491-14.434807 22.393263-14.434807 7.401544 0 14.434807 3.889404 14.434807 14.434807v111.975299c0 11.856842-28.869614 11.856842-28.869614 0v-69.407439l-17.767298 30.360702zM961.931228 420.612491h27.764772c11.416702 0 11.767018 22.213614 0 22.213614h-27.755789v31.465544h49.601122c11.443649 0 11.802947 25.168842 0 25.168842h-65.886315c-6.287719 0-12.593404-2.964211-12.593404-8.883649V373.050386c0-5.928421 6.287719-8.892632 12.593404-8.892632h65.886315c11.802947 0 11.434667 25.177825 0 25.177825h-49.601122v31.276912z"
                  fill="#6D6E71" p-id="1765"></path>
              </svg>

            </span>
            <div class="name-warp">
              <div class="name">{{ form.username }}</div>
              <!-- <div class="idcard">{{ form.idcard.replace(/(?<=\d{3})\d{12}(?=\d{2})/, '************') }}</div> -->
            </div>
          </div>
          <qrcode-vue class="qrcodeBox" :size="qrcodeVue.size" :value="'h5v_' + form.mainid" :logo="qrcodeVue.logo"
            :bgColor="qrcodeVue.bgColor" :fgColor="qrcodeVue.fgColor"></qrcode-vue>
          <div class="tip">
            出示二维码在门禁闸机上扫二维码进入园区
          </div>
          <div class="line"></div>
          <div class="info-warp">
            <div>{{ form.comapny }}</div>
            <div><span>邮箱：</span>{{ form.mobile }}</div>
            <div><span>被访人：</span>{{ form.toName }}</div>
            <div><span>时　间：</span>{{ form.startTime }}~{{ form.endTime }}</div>
            <div><span>事　由：</span>{{ form.reason }}</div>
            <div class="visiotr">访客证<br /><i>VISITOR</i></div>
          </div>
        </div>

      </div>

    </div>

    <van-popup v-if="show" v-model="show" class="popv">
      <div id="canvas"></div>
      <div class="tip">长按图片保存到手机</div>
    </van-popup>
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
import qrcodeVue from "qrcode-vue";

export default {
  props: ['form'],
  data() {
    return {
      show: false,
      qrcodeVue: {
        size: 50,
        bgColor: "#fff",
        fgColor: "#000",
        logo: undefined, //logo图片
      }
    }
  },
  mounted() {
  },
  components: { qrcodeVue },

  methods: {
    onLoad() {
      var $this = this;
      let toast = $this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      html2canvas(document.querySelector("#capture")).then(canvas => {
        console.log(canvas)
        const context = canvas.getContext('2d');
        // 关闭抗锯齿形
        context.mozImageSmoothingEnabled = false;
        context.webkitImageSmoothingEnabled = false;
        context.msImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false;
        // canvas转化为图片
        const img = this.canvas2Image(canvas, canvas.width, canvas.height);

        $this.show = true;
        $this.$nextTick(() => {
          toast.clear()
          document.getElementById('canvas').appendChild(img)
          img.style.cssText = "width:100vw;";
        })
      });
    },
    canvas2Image(canvas, width, height) {
      const retCanvas = document.createElement('canvas');
      const retCtx = retCanvas.getContext('2d');
      retCanvas.width = width;
      retCanvas.height = height;
      retCtx.drawImage(canvas, 0, 0, width, height, 0, 0, width, height);
      const img = document.createElement('img');
      img.src = retCanvas.toDataURL('image/jpeg');  // 可以根据需要更改格式
      return img;
    }
  }
}
</script>
<style lang="less" scoped>
.qr-image-warp {
  background: #e2000e;
  padding: 0px 0 20px 0;

  .logo {
    height: 80px;
    font-size: 30px;
    text-align: center;
    color: #FFF;
    letter-spacing: 2px;
    font-weight: bold;
    line-height: 80px;
  }

  .content {
    background: #FFF;
    border-radius: 10px;
    width: 92%;
    margin: 0 auto;
    padding: 30px;
    box-sizing: border-box;
  }

  .title {
    display: flex;

    .name-warp {
      flex: 1;
      text-align: right;

      span {
        height: 40px;
        width: 40px;
        justify-content: center;
      }

      .name {
        font-size: 26px;
        font-weight: bold;
      }

      .idcard {
        line-height: 50px;
      }
    }
  }

  .qrcodeBox {
    text-align: center;
    margin-top: 30px;
  }

  .tip {
    font-size: 13px;
    line-height: 30px;
    text-align: center;
    margin-top: 20px;
  }

  .line {
    border-top: solid 1px #eee;
    margin: 10px 0;
  }

  .info-warp {
    line-height: 25px;
    font-size: 14px;
    position: relative;
    text-align: left;

    span {
      display: inline-block;
      width: 60px;
      text-align: justify;
    }

    .visiotr {
      position: absolute;
      font-weight: bold;
      bottom: -20px;
      right: -25px;
      font-size: 28px;
      width: 100px;
      line-height: 30px;
      color: #e2000e;
      text-align: center;

      i {
        display: block;
        font-size: 20px;
        font-style: normal;
        width: 100px;
        text-align: center;
      }

    }
  }
}

.popv {
  padding: 0px 0 10px 0;
  background: none;

  #canvas {

    // width: 80vw;
    canvas {
      // width: 100% !important;
    }
  }

  .tip {
    text-align: center;
    line-height: 30px;
    color: #FFF;
    font-size: 13px;
  }
}
</style>